(() => {
  if (window.__SIZE_GUIDE_MODAL_FETCH_V2__) return;
  window.__SIZE_GUIDE_MODAL_FETCH_V2__ = true;

  const CFG = {
    hrefMustInclude: '/pages/size-',
    textMustInclude: 'size guide',
    limitToContainers: [],
    modalTitle: 'Size Guide'
  };

  const norm = (s) => (s || '').toString().trim().toLowerCase();

  function inAllowedContainer(el) {
    if (!CFG.limitToContainers.length) return true;
    return CFG.limitToContainers.some(sel => el.closest(sel));
  }

  function isSizeGuideLink(a) {
    if (!a || a.tagName !== 'A') return false;
    const href = a.getAttribute('href') || '';
    if (!href) return false;
    if (!href.includes(CFG.hrefMustInclude)) return false;
    if (!norm(a.textContent).includes(norm(CFG.textMustInclude))) return false;
    return true;
  }

  function ensureModal() {
    let wrap = document.getElementById('sgm-wrap');
    if (wrap) return wrap;

    const style = document.createElement('style');
    style.id = 'sgm-style';
    style.textContent = `
      #sgm-wrap{position:fixed;inset:0;z-index:2147483647;display:none}
      #sgm-backdrop{position:absolute;inset:0;background:rgba(0,0,0,.55)}
      #sgm-panel{
        position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);
        width:min(980px,calc(100vw - 28px));
        height:min(86vh,900px);
        background:#fff;border-radius:12px;overflow:hidden;
        box-shadow:0 20px 60px rgba(0,0,0,.35);
        font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
        display:flex;flex-direction:column;
      }
      #sgm-header{
        display:flex;align-items:center;justify-content:space-between;gap:12px;
        padding:12px 14px;border-bottom:1px solid rgba(0,0,0,.08);
        font-weight:700;font-size:14px;
      }
      #sgm-close{color:#000;border:0;background:transparent;cursor:pointer;font-size:22px;line-height:1;padding:6px 10px}
      #sgm-body{flex:1;overflow:auto;padding:14px}
      #sgm-loading{padding:14px;font-size:14px;opacity:.75}
      body.sgm-lock{overflow:hidden!important}
      #sgm-body img{max-width:100%;height:auto}
      #sgm-wrap [data-cc-animate],
      #sgm-wrap [data-cc-animate] * {
        opacity: 1 !important;
        transform: none !important;
        animation: none !important;
        transition: none !important;
      }
    `;
    document.head.appendChild(style);

    wrap = document.createElement('div');
    wrap.id = 'sgm-wrap';
    wrap.innerHTML = `
      <div id="sgm-backdrop" aria-hidden="true"></div>
      <div id="sgm-panel" role="dialog" aria-modal="true" aria-label="${CFG.modalTitle}">
        <div id="sgm-header">
          <div>${CFG.modalTitle}</div>
          <button id="sgm-close" type="button" aria-label="Close">&times;</button>
        </div>
        <div id="sgm-body">
          <div id="sgm-loading">Loading…</div>
        </div>
      </div>
    `;
    document.body.appendChild(wrap);

    wrap.querySelector('#sgm-close').addEventListener('click', hideModal);
    wrap.querySelector('#sgm-backdrop').addEventListener('click', hideModal);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && wrap.style.display === 'block') hideModal();
    });

    return wrap;
  }

  function showModal() {
    const wrap = ensureModal();
    wrap.style.display = 'block';
    document.body.classList.add('sgm-lock');
  }

  function hideModal() {
    const wrap = document.getElementById('sgm-wrap');
    if (!wrap) return;
    wrap.style.display = 'none';
    document.body.classList.remove('sgm-lock');
    wrap.querySelector('#sgm-body').innerHTML = `<div id="sgm-loading">Loading…</div>`;
  }

  function pickMainContent(doc) {
    const candidates = [
      'main',
      '[role="main"]',
      '#MainContent',
      '.content-for-layout',
      '.shopify-section',
      '.page-width',
      '.rte'
    ];
    for (const sel of candidates) {
      const el = doc.querySelector(sel);
      if (el && el.textContent.trim().length > 20) return el;
    }
    return doc.body;
  }

  async function loadAndRender(url) {
    const wrap = ensureModal();
    const body = wrap.querySelector('#sgm-body');
    body.innerHTML = `<div id="sgm-loading">Loading…</div>`;

    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      doc.querySelectorAll('script').forEach(s => s.remove());

      const main = pickMainContent(doc);
      const imported = document.importNode(main, true);

      imported.querySelectorAll('header, footer, nav').forEach(el => el.remove());

      imported.querySelectorAll('[data-cc-animate]').forEach(el => {
        el.removeAttribute('data-cc-animate');
        el.removeAttribute('data-cc-animate-delay');
        el.removeAttribute('data-cc-animate-duration');
        el.style.opacity = '1';
        el.style.transform = 'none';
      });

      const abs = (v) => {
        try { return new URL(v, url).href; } catch { return v; }
      };

      imported.querySelectorAll('a[href]').forEach(a => {
        const href = a.getAttribute('href');
        if (!href) return;
        a.setAttribute('href', abs(href));
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener');
      });

      imported.querySelectorAll('img[src], source[srcset], img[data-src], iframe[src]').forEach(el => {
        if (el.tagName === 'IMG' && el.getAttribute('src')) el.setAttribute('src', abs(el.getAttribute('src')));
        if (el.tagName === 'IFRAME' && el.getAttribute('src')) el.setAttribute('src', abs(el.getAttribute('src')));
        if (el.tagName === 'SOURCE' && el.getAttribute('srcset')) {
          el.setAttribute('srcset', el.getAttribute('srcset').split(',').map(p => {
            const part = p.trim().split(/\s+/);
            part[0] = abs(part[0]);
            return part.join(' ');
          }).join(', '));
        }
        if (el.tagName === 'IMG' && el.getAttribute('data-src')) el.setAttribute('data-src', abs(el.getAttribute('data-src')));
      });

      body.innerHTML = '';
      body.appendChild(imported);
    } catch (err) {
      body.innerHTML = `
        <div style="font-size:14px;line-height:1.45">
          We couldn't load this size guide inside a modal.<br/>
          <a href="${url}" target="_blank" rel="noopener" style="text-decoration:underline;font-weight:700">
            Open size guide in a new tab
          </a>
        </div>
      `;
    }
  }

  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]');
    if (!a) return;
    if (!inAllowedContainer(a)) return;
    if (!isSizeGuideLink(a)) return;

    e.preventDefault();
    e.stopPropagation();

    const url = new URL(a.getAttribute('href'), location.href).href;
    showModal();
    loadAndRender(url);
  }, true);
})();
